var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-text',[_c('h3',[_c('feather-icon',{attrs:{"icon":"HelpCircleIcon","size":"22"}}),_vm._v(" إرشادات")],1),_c('hr'),_c('p',[_vm._v("هذه الصفحات تظهر عند انتظار الموافقة على طلب التأسيس من قبل الوزارة")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }